<a class="ds-tab-head"
   [ngClass]="{
   'ds-tab-head_active': !tabId || tabId === activeTabId,
   'inline':inline,
   'small': !!size && size === 's',
   'ds-hide-tab': hideTab,
   'with-border': withBorder,
   'black': blackStyle}"
   (click)="onClick()">
  <ng-content></ng-content>
</a>
